import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';

import { AppBar, Toolbar, Hidden, IconButton, Typography } from '@material-ui/core';

import MenuIcon from '@material-ui/icons/Menu';
import StorefrontIcon from '@material-ui/icons/Storefront';

import UserProfile from '../../../../UserProfile';
import JournalMarche from '../../../../JournalMarche';

const useStyles = makeStyles(theme => ({
    appBar: {
        backgroundColor: '#FFFFFF',
        borderBottom: '1px solid #E8E9EE',
        boxShadow: 'none',
        zIndex: theme.zIndex.drawer - 1,
        [theme.breakpoints.up('lg')]: {
            display: 'none'
        }
    },
    toolbar: {
        minHeight: 48,
        padding: '0 16px',
        gap: 8,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
    },

    // ── Hamburger (mobile) ──
    menuButton: {
        color: '#9B9AB8',
        padding: 6,
        marginRight: 4,
        '&:hover': {
            backgroundColor: '#F0F0F6',
            color: '#3D3C58'
        }
    },

    // ── Market chip (placier) ──
    marketChip: {
        display: 'flex',
        alignItems: 'center',
        gap: 6,
        backgroundColor: '#F0F7FD',
        border: '1px solid #C5DDF0',
        borderRadius: 6,
        padding: '4px 10px',
        color: '#1A6FA3',
        fontSize: 12,
        fontWeight: 500,
        '& svg': {
            fontSize: 14,
            flexShrink: 0
        }
    },

    // ── Date label ──
    dateLabel: {
        fontSize: 11,
        color: '#9B9AB8',
        whiteSpace: 'nowrap'
    },

    // ── Spacer ──
    spacer: {
        flex: 1
    },

    // ── Action buttons ──
    divider: {
        margin: '0 8px',
        height: 20
    },
    iconBtn: {
        color: '#9B9AB8',
        padding: 6,
        borderRadius: 8,
        position: 'relative',
        '&:hover': {
            backgroundColor: '#F0F0F6',
            color: '#3D3C58'
        },
        '& svg': {
            fontSize: 18
        }
    },
    notifDot: {
        position: 'absolute',
        top: 7,
        right: 7,
        width: 7,
        height: 7,
        borderRadius: '50%',
        backgroundColor: '#E85D24',
        border: '1.5px solid #fff'
    },

    // ── Profile avatar ──
    avatarBtn: {
        width: 30,
        height: 30,
        borderRadius: '50%',
        background: 'linear-gradient(135deg, #3A7BD5, #7F5EA3)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: 11,
        fontWeight: 600,
        color: '#fff',
        cursor: 'pointer',
        flexShrink: 0,
        border: 'none'
    }
}));

const Topbar = props => {
    const { className, onSidebarOpen, ...rest } = props;
    const classes = useStyles();
    const profile = UserProfile.getProfile()?.toLowerCase();
    const isPlacier = profile === 'placier';

    return (
        <AppBar {...rest} position="relative" className={clsx(classes.appBar, className)}>
            <Toolbar className={classes.toolbar} disableGutters>
                <Hidden lgUp>
                    <IconButton className={classes.menuButton} onClick={onSidebarOpen} size="small">
                        <MenuIcon />
                    </IconButton>
                </Hidden>

                {isPlacier && JournalMarche.getId() > 0 ? (
                    <div className={classes.marketChip}>
                        <StorefrontIcon />
                        <Typography variant="body2" style={{ color: '#1A6FA3', fontSize: 12 }}>
                            {JournalMarche.getLabel?.() || 'Marché'}
                        </Typography>
                    </div>
                ) : null}
            </Toolbar>
        </AppBar>
    );
};

Topbar.propTypes = {
    className: PropTypes.string,
    onSidebarOpen: PropTypes.func
};

export default Topbar;
